export default __webpack_public_path__ + "static/noise-c0e6992315ac6e9234d9ee3bb56336b1.png";